export const bondData = [{
    "id":"1",
    "name":"Bonda ",
    "price":"Price : ₹50 /- ",
    "image": process.env.PUBLIC_URL + "/assests/bonda/1.jpg",
    "description":"Crispy outside and soft inside, traditional fried snack served with spicy ginger chutney."
}]